<template>
  <div class="footer">
    <div
      v-if="divider"
      class="divider"
    />
    <div class="wrapper">
      <div class="info">
        <div class="links">
          <div
            v-if="socialLinks"
            class="media"
          >
            <AuIcon
              v-if="linkedin != 'none'"
              icon="linkedin"
              class="btn"
              is-link
              :href="linkedin"
              target="_blank"
            />
            <AuIcon
              v-if="instagram != 'none'"
              icon="instagram"
              class="btn"
              is-link
              :href="instagram"
              target="_blank"
            />
            <AuIcon
              v-if="discord != 'none'"
              icon="discord"
              class="btn"
              is-link
              :href="discord"
              target="_blank"
            />
            <AuIcon
              v-if="language == 'ru' && vk != 'none'"
              icon="vk"
              class="btn"
              is-link
              :href="vk"
              target="_blank"
            />
            <AuIcon
              v-if="youtube != 'none'"
              icon="youtube"
              class="btn"
              is-link
              :href="youtube"
              target="_blank"
            />
            <AuIcon
              v-if="telegram != 'none'"
              icon="telegram"
              class="btn"
              is-link
              :href="telegram"
              target="_blank"
            />
            <AuIcon
              v-if="twitter != 'none'"
              icon="twitter"
              class="btn"
              is-link
              :href="twitter"
              target="_blank"
            />
            <AuIcon
              v-if="language == 'ru' && dzen != 'none'"
              icon="dzen"
              class="btn"
              is-link
              :href="dzen"
              target="_blank"
            />
            <AuIcon
              v-if="fb != 'none'"
              icon="facebook"
              class="btn"
              is-link
              :href="fb"
              target="_blank"
            />
          </div>

          <div class="policy">
            <a
              v-if="hrefPolicy"
              :href="hrefPolicy"
              target="_blank"
            >{{
              $t("footer.privacyPolicy")
            }}</a>
            <a
              v-if="hrefAgreement"
              :href="hrefAgreement"
              target="_blank"
            >{{
              $t("footer.termsOfUse")
            }}</a>

            <template v-if="isRwa">
              <RouterLink
                to="/terms-of-use"
              >
                {{ $t("footer.termsOfUse") }}
              </RouterLink>
              <RouterLink
                to="/risk-disclosure"
              >
                {{ $t("footer.riskDisclosure") }}
              </RouterLink>
              <RouterLink
                to="/complaints-procedure"
              >
                {{ $t("footer.complaints") }}
              </RouterLink>
              <RouterLink
                to="/cookie-policy"
              >
                {{ $t("footer.cookiePolicy") }}
              </RouterLink>
              <RouterLink
                to="/aml-policy"
              >
                {{ $t("footer.amlPolicy") }}
              </RouterLink>
              <RouterLink
                to="/privacy-policy"
              >
                {{ $t("footer.privacyPolicy") }}
              </RouterLink>
              <RouterLink
                to="/faq"
              >
                {{ $t("footer.faq") }}
              </RouterLink>
            </template>
          </div>
        </div>

        <div class="copyright">
          {{ titleFooter }}
        </div>
      </div>
    </div>
    <div
      v-if="isMobile"
      class="nav-button"
    >
      <AuButton
        type="primary"
        width="25%"
        height="60px"
        border-radius="0"
        center
        @click="goToRoute('dashboard')"
      >
        <div class="cap">
          <img
            src="/img/dashboard/grid_round.svg"
            alt="dashboard"
          >
          <span>
            {{ $t("router.pages.dashboard") }}
          </span>
        </div>
      </AuButton>
      <AuButton
        type="primary"
        width="25%"
        height="60px"
        border-radius="0"
        center
        @click="goToRoute('my assets')"
      >
        <div class="cap">
          <img
            src="/img/dashboard/bag.svg"
            alt="dashboard"
          >
          <span>
            {{ $t("router.pages.briefcase") }}
          </span>
        </div>
      </AuButton>
      <AuButton
        type="primary"
        width="25%"
        height="60px"
        border-radius="0"
        center
        @click="goToRoute('projects')"
      >
        <div class="cap">
          <img
            src="/img/dashboard/projects.svg"
            alt="dashboard"
          >
          <span>
            {{ $t("router.pages.project") }}
          </span>
        </div>
      </AuButton>
      <AuButton
        type="primary"
        width="25%"
        height="60px"
        border-radius="0"
        center
        @click="goToRoute('transactions')"
      >
        <div class="cap">
          <img
            src="/img/dashboard/swap_vertical.svg"
            alt="dashboard"
          >
          <span>
            {{ $t("router.pages.transactions") }}
          </span>
        </div>
      </AuButton>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { checkAccess, scope } from "@/help/accessData";
import { getCopyright } from "@/help/copyright";
import { mapActions, mapGetters } from "vuex";
export default {

  props: {
    divider: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      language: "language",
      apiSystemSettings: "apiSystemSettings"
    }),

    languageTitle() {
      return _.chain(this.languages).find(x => x.value == this.language).get("display").value();
    },
    isLoginPage() {
      return this.$route?.name == "login" || this.$route?.name == "sign";
    },
    titleFooter() {
      return getCopyright() || process.env.VUE_APP_TITLE_FOOTER || "«Autentic»";
    },
    hrefPolicy() {
      return this.apiSystemSettings?.tmpEmailPrivacyLink != "none" ? this.apiSystemSettings?.tmpEmailPrivacyLink : false;
    },
    hrefAgreement() {
      return this.apiSystemSettings?.tmpEmailTermsLink != "none" ? this.apiSystemSettings?.tmpEmailTermsLink : false;
    },
    socialLinks() {
      return process.env.VUE_APP_SOCIAL_LINKS === "true";
    },
    discord() {
      return this.apiSystemSettings?.socialDiscordLink || "none";
    },
    vk() {
      return this.apiSystemSettings?.socialVkLink || "none";
    },
    youtube() {
      return this.apiSystemSettings?.socialYoutubeLink || "none";
    },
    telegram() {
      return this.apiSystemSettings?.socialTgLink || "none";
    },
    twitter() {
      return this.apiSystemSettings?.socialXLink || "none";
    },
    dzen() {
      return this.apiSystemSettings?.socialDzenLink || "none";
    },
    fb() {
      return this.apiSystemSettings?.socialFbLink || "none";
    },
    linkedin() {
      return this.apiSystemSettings?.socialLinkedinLink || "none";
    },
    instagram() {
      return this.apiSystemSettings?.socialInstagramLink || "none";
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        && this.$route.name !== "login";
    },
    isRwa() {
      return !checkAccess(scope.notRwa);
    }
  },
  methods: {
    ...mapActions({
      getBalances: "getBalances",
      patchCurrentUser: "patchCurrentUser"
    }),

    goToRoute(name) {
      this.$router.push({ name: name });
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  flex-direction: column;
}

.wrapper {
  display: flex;
  justify-content: space-between;
  gap: 50px;
}

.links {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .media {
    display: flex;
    justify-content: flex-start;
    gap: 5px;
    width: 100%;
    margin-left: -15px;
  }

  .policy {
    display: flex;
    width: 100%;
    gap: 20px;

    @media screen and (max-width: 800px) {
      flex-direction: column;
    }

    a {
      text-decoration: underline;
      white-space: nowrap;
      color: var(--text-color);
    }
  }
}

.copyright {
  margin-top: 10px;
  font-size: 13px;
  color: var(--text-color);
}
.small {
  width: 13px;
  height: 11px;
}
.nav-button {
  display: none;
  @media screen and (max-width: 800px) {
    display: flex;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  .cap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    img {
      width: 14px;
      height: 14px;
    }
  }
}
</style>